<template>
  <b-container>
    <Loading v-if="isLoading" :active.sync="isLoading"></Loading>
    <b-card class="page-body" body-class="has-footer">
      <CRow>
        <CCol cols="12" class="d-flex justify-content-center mb-4">
          <img class="header-img" src="../../assets/images/logo-indocyber.png">
        </CCol>
      </CRow>
      <CRow>
        <CCol cols="12" class="d-flex justify-content-center my-2">
          <router-link :to="{ path: '/' }">
            &lt;&lt;&lt; Return to OCR
          </router-link>
        </CCol>
      </CRow>
      <CRow>
        <CCol cols="12" class="d-flex justify-content-center my-2">
          <h1 class="page-greetings">
            History
          </h1>
        </CCol>
      </CRow>
      <CRow>
        <CCol cols="12" class="form-button mt-4">
          <b-table-lite
            id="my-table"
            :fields="fields"
            :items="items"
            bordered small
          >
            <template #cell(timestamp)="row">
              <router-link v-if="row.item.status == '1' || row.item.status == '2'" :to="{ path: `/history/${row.item.id}` }">
                {{ row.item.timestamp }}
              </router-link>
              <span v-else>{{ row.item.timestamp }}</span>
            </template>
            <template #cell(status)="row">
              <span v-if="row.item.status == '1'" class="text-success">Finished</span>
              <span v-else-if="row.item.status == '2'" class="text-danger">Failed</span>
              <span v-else-if="row.item.status == '0'">Processing</span>
              <span v-else>-</span>
            </template>
          </b-table-lite>
          <b-pagination 
              pills 
              class="mt-3"
              size="sm"
              align="right"
              v-model="currentPage"
              :total-rows="totalData"
              :per-page="perPage"
              @change="getItems"
          ></b-pagination>
        </CCol>
      </CRow>
      <TheFooter></TheFooter>
    </b-card>
      <Modal v-if="showErrorModal" :foreground="true" :closeButton="false">
        <div slot="body">
          <label>{{errorLabel}}</label>
          <div class="btn-footer">
            <button class="btn-submit white" @click="showErrorModal = false">
              Tutup
            </button>
          </div>
        </div>
      </Modal>
  </b-container>
</template>
<script>
import TheFooter from  '../TheFooter';
import Modal from  '../Modal';
import moment from 'moment';

export default {
  name: 'Main',
  components: {
    TheFooter,
    Modal
  },
  data(){
    return {
      isLoading: false,
      showErrorModal: false,
      errorLabel: "Terjadi kesalahan pada server. Silahkan coba lagi.",
      errorReload: false,
      originalDoc: null,
      compareDocs: [],
      fields: [
          { key: 'timestamp', label: 'Timestamp', thStyle: { width: '27.5%' } },
          { key: 'oridoc', label: 'Original Document', thStyle: { width: '57.5%' }, tdClass: 'td-ellipsis' },
          { key: 'status', label: 'Status', thStyle: { width: '15%' } },
      ],
      currentPage: 1,
      perPage: 20,
      totalData: 0,
      totalPages: 0,
      items: [],
      resultCompare: [],
      activeTab: 0,
    }
  },
  created() {
      this.getItems()
  },
  methods: {
    getItems(page = 1) {

        this.isLoading = true
        this.isError = false
        this.errorMessage = ""
        this.currentPage = page

        let url = `/history/get-all?page=${this.currentPage}&size=${this.perPage}`
        
        this.$axios.get(url).then(response => {
            if (
                response.status === 200 &&
                response.data &&
                response.data.success
            ) {
              this.items = response.data.data.data.map(item => {
                return {
                  id: item.id,
                  timestamp: moment(item.created_at, "DD-MM-YYYY HH:mm:ss").add(this.$tzOffset, "minutes").locale("id").format("YYYY/MM/DD HH:mm:ss"),
                  oridoc: item.filename,
                  status: item.status
                }
              })
              this.totalPages = response.data.data.total_page
              this.totalData = response.data.data.total_data
            } else {
                if (response.data && response.data.message)
                    this.errorMessage = response.data.message
                else this.errorMessage = 'An unknown error has occured.'
                this.isError = true
            }
        })
        .catch(error => {
            if (error.code && error.message)
                this.errorMessage = `${error.code}: ${error.message}`
            else this.errorMessage = 'An unknown error has occured.'
            this.isError = true
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  }
}
</script>